import { render, staticRenderFns } from "./ERegistrationIAmSmartTermAndCondForPublicView.vue?vue&type=template&id=05e12dbe&scoped=true&"
import script from "./ERegistrationIAmSmartTermAndCondForPublicView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationIAmSmartTermAndCondForPublicView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e12dbe",
  null
  
)

export default component.exports